/**
 * 模块名称: 系统公告管理详情页
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import { parseSearch, judgeCryptoParamsUrl } from '@/utils'
import DetailsComp from '@/components/Details'
import urls from '@/api/urls'
import api from '@/api'
import { message } from 'antd'

const BulletinSon = (props) => {
  const { history } = props
  const search = parseSearch(props.location.search)
  const [data, setData] = useState({
    id: '',
    title: '',
    crateTime: '',
    createBy: '',
    content: '',
    accessories: []
  })

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      api.getSysNoticeDetails({ id: search.id }, true).then(data => {
        api.setNoticeReaded({ id: search.id })
        setData(data)
      })
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.go(-2)
      }, 1000)
    }
  }, [])

  return (
    <DetailsComp
      data={data}
      onClose={history.goBack}
      url={data.accessories.length ? `${urls.downloadNoticeAffix.url}?id=${data.id}` : null}
    />
  )
}

export default BulletinSon
